import load from '#core/load';


const href_attr = 'href';
const target_attr = 'target';
const rel_attr = 'rel';
const any_link_$ = 'a[href]';

const blank_target = '_blank';
const external_rel_values = ['noopener', 'noreferrer'];
const external_protocols = ['http:', 'https:'];


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('external-links')) return false;

		load.content(() => {
			module.convert();
		});
	},


	/**
	 * Convert all external links on the page
	 *
	 * Safe to call again after content is added to the page dynamically;
	 * links that have already been converted are unaffected.
	 */
	convert() {
		document.querySelectorAll(any_link_$).forEach($link => {
			convert_link($link);
		});
	},

};

export default module;
module.init();


/**
 * Make an external link open in a new window
 *
 * A link is external if it points to a different host than the current page.
 * Non-web links (mailto:, tel:, etc.) are left alone, as is any link with an
 * explicit target already set (e.g. an editor-supplied target="_self").
 * Converted links also get rel="noopener noreferrer" so the destination page
 * can't access window.opener or read the referring URL.
 *
 * @param {element} $link
 */
function convert_link($link) {
	if (!is_external($link)) return false;

	if (!$link.getAttribute(target_attr)) {
		$link.setAttribute(target_attr, blank_target);
	}

	const rel_values = ($link.getAttribute(rel_attr) || '').split(/\s+/).filter(Boolean);
	external_rel_values.forEach(value => {
		if (rel_values.includes(value)) return;

		rel_values.push(value);
	});
	$link.setAttribute(rel_attr, rel_values.join(' '));
}


/**
 * Does this link point to a different site?
 *
 * The www subdomain is ignored when comparing hosts, so www.example.com and
 * example.com count as the same site.
 *
 * @param {element} $link
 * @return {boolean}
 */
function is_external($link) {
	const href = $link.getAttribute(href_attr);
	if (!href) return false;

	let url;
	try {
		url = new URL(href, window.location.href);
	} catch {
		return false;
	}
	if (!external_protocols.includes(url.protocol)) return false;

	return normalize_hostname(url.hostname) !== normalize_hostname(window.location.hostname);
}


/**
 * Normalize a hostname for comparison
 * @param {string} hostname
 * @return {string}
 */
function normalize_hostname(hostname) {
	return hostname.toLowerCase().replace(/^www\./, '');
}
